import { render, staticRenderFns } from "./AdditionalDocuments.vue?vue&type=template&id=e3a8903a&scoped=true"
import script from "./AdditionalDocuments.vue?vue&type=script&lang=js"
export * from "./AdditionalDocuments.vue?vue&type=script&lang=js"
import style0 from "./AdditionalDocuments.vue?vue&type=style&index=0&id=e3a8903a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a8903a",
  null
  
)

export default component.exports